import { render, staticRenderFns } from "./FerramentasSentinelHub.vue?vue&type=template&id=b36d3408&lang=pug"
import script from "./FerramentasSentinelHub.vue?vue&type=script&lang=js"
export * from "./FerramentasSentinelHub.vue?vue&type=script&lang=js"
import style0 from "./FerramentasSentinelHub.vue?vue&type=style&index=0&id=b36d3408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports